import type { ComponentType, HTMLAttributes } from 'react';
import styled from 'styled-components';

import type { TextTag } from './Text';

/** Optional raw CSS string applied to a text host (the `styleText` prop). */
export type HostProps = { $styleText?: string };

const injectStyleText = (props: HostProps): string => props.$styleText ?? '';

/**
 * One styled host element per supported tag. `<Text>` renders the translated
 * value as a child of the host (auto-escaped) — never via dangerouslySetInnerHTML.
 * Each host injects the optional raw `styleText`.
 */
export const HOSTS: Record<
  Exclude<TextTag, 'paragraph'> | 'p',
  ComponentType<HostProps & HTMLAttributes<HTMLElement>>
> = {
  span: styled.span<HostProps>(injectStyleText),
  div: styled.div<HostProps>(injectStyleText),
  p: styled.p<HostProps>(injectStyleText),
  h1: styled.h1<HostProps>(injectStyleText),
  h2: styled.h2<HostProps>(injectStyleText),
  h3: styled.h3<HostProps>(injectStyleText),
  h4: styled.h4<HostProps>(injectStyleText),
  h5: styled.h5<HostProps>(injectStyleText),
  h6: styled.h6<HostProps>(injectStyleText),
};
